import { PARSER_CONFIG, REGEX_PATTERNS } from '../constants';
import { TreeNode } from '../types';

import { BaseParser } from './BaseParser';

export class PlainTextParser extends BaseParser {
  readonly name = 'PlainTextParser';

  canParse(input: string): boolean {
    // Reject empty or whitespace-only input
    if (!input?.trim()) {
      return false;
    }

    // Quick rejection checks
    if (
      input.includes('\t') ||
      input.includes('<li') ||
      REGEX_PATTERNS.numberedList.test(input) ||
      REGEX_PATTERNS.bulletListInline.test(input)
    ) {
      return false;
    }

    const lines = input.split('\n', PARSER_CONFIG.maxLinesToCheck);
    return lines.length > 0 && !lines.some((line) => REGEX_PATTERNS.whitespace.test(line));
  }

  protected parseInternal(input: string): TreeNode[] {
    const lines = input.split('\n');
    const nodes: TreeNode[] = [];

    for (const line of lines) {
      const label = line.trim();
      if (!label) continue;

      nodes.push(this.createNode(label));
    }

    return nodes;
  }
}
